export { FundType } from './fund.enum';
